import {REGISTER_USER, REGISTER_USER_ERROR, REGISTER_USER_SUCCESS} from "./actionTypes";

export const registerUser = (user, history) => {
    return {
        type: REGISTER_USER,
        payload: {user, history}
    };
};

export const registerUserSuccess = () => {
    return {
        type: REGISTER_USER_SUCCESS,
        payload: {}
    };
};

export const registerUserError = (user) => {
    return {
        type: REGISTER_USER_ERROR,
        payload: user
    };
};
